import { render, staticRenderFns } from "./quote-issue-policy.vue?vue&type=template&id=65d06481&"
import script from "./quote-issue-policy.vue?vue&type=script&lang=js&"
export * from "./quote-issue-policy.vue?vue&type=script&lang=js&"
import style0 from "./quote-issue-policy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports